<script setup lang="ts">
import { labelToNodeTypes } from '~/utils/solr/search-utils'

const open = defineModel('open', {
  default: false,
})

const page = ref<number>(1)

const selectedContentTypes = ref<string[]>([])

function toggleContentType(type: string, checked: boolean, singleSelect = false) {
  if (singleSelect) {
    selectedContentTypes.value = checked ? [type] : []
  }
  else if (checked) {
    if (!selectedContentTypes.value.includes(type)) {
      selectedContentTypes.value = [...selectedContentTypes.value, type]
    }
  }
  else {
    selectedContentTypes.value = selectedContentTypes.value.filter(i => i !== type)
  }
}

function resetContentType() {
  selectedContentTypes.value = []
}

const filters = computed(() => ({
  contentTypes: selectedContentTypes.value.flatMap(g => labelToNodeTypes[g.toLowerCase()] || []),
}))

const sort = computed(() => '')

const searchState = useSearchState({ requestKind: 'preview', page, filters, sort })
const { totalResults, isLoading, facets, highlighting, searchResult, spellcheckSuggestion } = searchState

const { contentTypeOptions } = useSearchFacetOptions(facets)

const filteredResults = useHighlightedResults(highlighting, searchResult, searchState.term)

useSearchHistoryTracker('global', searchState.term, searchState.searchResult, searchState.isLoading)

const container = useTemplateRef('container')

onClickOutside(container, () => {
  open.value = false
}, {
  ignore: ['[data-search-toggle]'],
})

onKeyStroke('Escape', () => {
  open.value = false
})
</script>

<template>
  <div v-if="open" ref="container" class="absolute top-full left-0 right-0 h-80 pt-xl rounded-b-4xl bg-[--background]">
    <SearchGlobalInput
      v-model:open="open"
      placeholder="Søk i hele Juridika"
      :content-type-options="contentTypeOptions"
      :search-results="filteredResults"
      :total-results="totalResults"
      :is-loading="isLoading"
      :toggle-content-type="toggleContentType"
      :selected-content-types="selectedContentTypes"
      :reset-content-type="resetContentType"
      :spellcheck-suggestion="spellcheckSuggestion"
      class="mx-auto w-full max-w-[837px]"
    />
  </div>
</template>
